import { useEffect, useRef, useState } from "react";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import BasicInformation from "../basicinformation/BasicInformation";
import ClinicainPricing from "../clinicianpricing/ClinicianPricing";
import ClinicianEducation from "../clinicianeducation/ClinicianEducation";
import ClinicianExperience from "../clinicianexperience/ClinicianExperience";
import ClinicianAwards from "../clinicianawards/ClinicianAwards";
import ClinicianSocialMedia from "../cliniciansocialmedia/ClinicianSocialMedia";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import classes from "./ClinicianComponent.module.css";
import {
  alphabetsNumberRegex,
  alphabetsRgex,
  facebookRegex,
  linkedinRegex,
  twitterRegex,
  mobileNoRegex,
} from "../../../commoncomponents/input/Regex";
import {
  getRequest,
  postAxios,
  singoutHandler,
} from "../../../../api/AxiosAPICall";
import { Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useNavigate, useNavigationType } from "react-router-dom";

export let clinicianDetailobject = {
  userName: "",
  emailId: "",
  firstName: "",
  lastName: "",
  birthDate: "",
  mobileNo: "",
  gender: "",
  totalExperiance: "",
  eliId: "",
  department: "",
  mbttNumber: "",
  biography: "",
  etpId: "new",
  price: false,
  enterAmount: "",
  service: [],
  specialization: [],
  monday: [
    {
      clinicType: "",
      clinicLocations: "",
      noAppointments: "",
      timingSlotDuration: "",
      startTime: "",
      endTime: "",
      setAsDefault: "",
    },
  ],
  tuesday: [
    {
      clinicType: "",
      clinicLocations: "",
      noAppointments: "",
      timingSlotDuration: "",
      startTime: "",
      endTime: "",
      setAsDefault: "",
    },
  ],
  wednesday: [
    {
      clinicType: "",
      clinicLocations: "",
      noAppointments: "",
      timingSlotDuration: "",
      startTime: "",
      endTime: "",
      setAsDefault: "",
    },
  ],
  thursday: [
    {
      clinicType: "",
      clinicLocations: "",
      noAppointments: "",
      timingSlotDuration: "",
      startTime: "",
      endTime: "",
      setAsDefault: "",
    },
  ],
  friday: [
    {
      clinicType: "",
      clinicLocations: "",
      noAppointments: "",
      timingSlotDuration: "",
      startTime: "",
      endTime: "",
      setAsDefault: "",
    },
  ],
  saturday: [
    {
      clinicType: "",
      clinicLocations: "",
      noAppointments: "",
      timingSlotDuration: "",
      startTime: "",
      endTime: "",
      setAsDefault: "",
    },
  ],
  sunday: [
    {
      clinicType: "",
      clinicLocations: "",
      noAppointments: "",
      timingSlotDuration: "",
      startTime: "",
      endTime: "",
      setAsDefault: "",
    },
  ],
  educations: [{ eeaId: "new", degree: "", college: "", educationDate: "" }],
  experinces: [
    {
      eeaId: "new",
      hospital: "",
      designation: "",
      experinceStartDate: "",
      experinceEndDate: "",
    },
  ],
  awards: [{ eeaId: "new", collegeawards: "", awardsDate: "" }],
  facebookLink: "",
  twitterLink: "",
  linkedInLink: "",
};

let successMessage: string[] = [];
const ClinicianMain = (props: any) => {
  const [basicinformation, setBasicInformation] = useState<any>([]);
  const [pricingData, setPricingData] = useState<any>([]);
  const [educationDetails, setEducationDetails] = useState<any>([]);
  const [experianceDetails, setExperianceDetails] = useState<any>([]);
  const [awardsDetails, setAwardsDetails] = useState<any>([]);
  const [socialMediaDetails, setSocialMediaDetails] = useState<any>([]);
  const [deletedEeaId, setDeletedEeaId] = useState<any>([]);
  const [deletedExperianceEeaId, setDeletedExperianceEeaId] = useState<any>([]);
  const [deletedAwardEeaId, setDeletedAwardEeaId] = useState<any>([]);
  const [disableSubmit, setDisableSubmit] = useState<any>(false);
  const [updateBasicInfoLoader, setUpdateBasicInfoLoader] = useState(false);
  const [updatePriceLoader, setUpdatePriceLoader] = useState(false);
  const [updateEducationLoader, setUpdateEducationLoader] = useState(false);
  const [updateExperianceLoader, setUpdateExperianceLoader] = useState(false);
  const [updateAwardLoader, setUpdateAwardLoader] = useState<any>(false);
  const [isUserEmailPresent, setIsUserEmailPresent] = useState(false);
  const [isUserMobilePresent, setIsUserMobilePresent] = useState(false);
  const [
    updateServiceSpecializationLoader,
    setUpdateServiceSpecializationLoader,
  ] = useState(false);
  const socialMediaLoader = useRef<any>();
  const dispatch = useDispatch();
  let history = useNavigate();
  let navType = useNavigationType();
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }

  useEffect(() => {
    return () => {
      if (navType === "POP") {
        history("/unauthenticatedUser");
      }
    };
  }, [navType, history]);

  const getCloseSnackbar = (mode: string) => {
    if (mode === "basicinformationSnackbar") {
      setUpdateBasicInfoLoader(false);
    } else if (mode === "priceSnackbar") {
      setUpdatePriceLoader(false);
    } else if (mode === "experienceSnackbar") {
      setUpdateExperianceLoader(false);
    } else if (mode === "awardSnackbar") {
      setUpdateAwardLoader(false);
    } else if (mode === "educationSnackbar") {
      setUpdateEducationLoader(false);
    } else if (mode === "serviceSnackbar") {
      setUpdateServiceSpecializationLoader(false);
    }

    if (
      !updateBasicInfoLoader &&
      !updatePriceLoader &&
      !updateEducationLoader &&
      !updateExperianceLoader &&
      !updateAwardLoader &&
      !updateServiceSpecializationLoader &&
      successMessage.length > 0
    ) {
      const finalSuccessMessage = successMessage.filter((value, id, array) => {
        return array.indexOf(value) === id;
      });
      dispatch(
        setSnackbar(
          true,
          3000,
          "success",
          `${finalSuccessMessage.join(" ")} `,
          "bottom",
          "left"
        )
      );
      successMessage = [];
    }
  };
  const getBasicinformation = (basicinformation: any) => {
    if (basicinformation !== undefined) {
      setBasicInformation(basicinformation);
      if (
        basicinformation?.additionalDetails?.socialMediaDetails !== undefined
      ) {
        setSocialMediaDetails(
          basicinformation?.additionalDetails.socialMediaDetails
        );
      }
    }
  };

  const getPrice = (price: any) => {
    if (price !== undefined) {
      setPricingData(price);
    }
  };
  const getSocialMediaLoader = (loader: any) => {
    socialMediaLoader.current = loader;
  };
  const getEducationDetails = (educationDetails: any) => {
    if (educationDetails !== undefined) {
      setEducationDetails(educationDetails);
    }
  };

  const getEducationEeaId = (eeaId: any) => {
    if (eeaId !== "new") {
      setDeletedEeaId((prevArray: any) => [...prevArray, eeaId]);
    }
  };

  const getExperianceEeaId = (eeaId: any) => {
    if (eeaId !== "new") {
      setDeletedExperianceEeaId((prevArray: any) => [...prevArray, eeaId]);
    }
  };

  const getExperianceDetails = (experianceDetails: any) => {
    if (experianceDetails !== undefined) {
      setExperianceDetails(experianceDetails);
    }
  };

  const getAwardEeaId = (eeaId: any) => {
    if (eeaId !== "new") {
      setDeletedAwardEeaId((prevArray: any) => [...prevArray, eeaId]);
    }
  };

  const getAwardsDetails = (awardsDetails: any) => {
    if (awardsDetails !== undefined) {
      setAwardsDetails(awardsDetails);
    }
  };

  const basicInformation = () => {
    let userDetails = {};
    //This if used for basicinformation component post data
    if (
      basicinformation.espId !== undefined &&
      basicinformation.espId !== null &&
      basicinformation.espId !== ""
    ) {
      Object.assign(userDetails, {
        espId: basicinformation.espId,
      });
    }
    if (
      basicinformation.cliId !== undefined &&
      basicinformation.cliId !== null &&
      basicinformation.cliId !== ""
    ) {
      Object.assign(userDetails, {
        cliId: basicinformation.cliId,
      });
    }

    if (basicinformation.useFirstname !== formik.values.firstName) {
      Object.assign(userDetails, {
        firstname: formik.values.firstName,
      });
    }

    if (basicinformation.useSurname !== formik.values.lastName) {
      Object.assign(userDetails, {
        surname: formik.values.lastName,
      });
    }

    if (basicinformation.useGender !== formik.values.gender) {
      Object.assign(userDetails, {
        gender: formik.values.gender,
      });
    }

    if (
      formik.values?.mobileNo !== undefined &&
      formik.values?.mobileNo !== null &&
      formik.values?.mobileNo !== "" &&
      basicinformation.useMobile !== null &&
      basicinformation.useMobile !== formik.values?.mobileNo
    ) {
      Object.assign(userDetails, {
        mobile: formik.values.mobileNo,
      });
    }

    if (
      formik.values?.emailId !== undefined &&
      formik.values?.emailId !== null &&
      formik.values?.emailId !== "" &&
      formik.values?.emailId !== basicinformation.useEmail
    ) {
      Object.assign(userDetails, {
        email: formik.values.emailId,
      });
    }

    return userDetails;
  };

  const additionalDetails = () => {
    let additionalDetails = {};

    if (
      (formik.values?.birthDate !== undefined &&
        formik.values?.birthDate !== null &&
        moment(formik.values?.birthDate).isValid() !== false &&
        basicinformation.additionalDetails?.eleDob !==
          moment(formik.values.birthDate).format("YYYY-MM-DD")) ||
      (formik.values?.totalExperiance !== undefined &&
        formik.values?.totalExperiance !== null &&
        basicinformation.additionalDetails?.eleYearOfExperience !==
          formik.values?.totalExperiance) ||
      (formik.values?.eliId !== undefined &&
        formik.values?.eliId !== null &&
        formik.values?.eliId !== "" &&
        basicinformation.additionalDetails?.eleDepartmentEliId !==
          formik.values?.eliId) ||
      (formik.values?.department !== undefined &&
        formik.values?.department !== null &&
        formik.values?.department !== "" &&
        basicinformation.additionalDetails?.eleDepartmentEliName !==
          formik.values?.department) ||
      (formik.values?.mbttNumber !== undefined &&
        formik.values?.mbttNumber !== null &&
        formik.values?.mbttNumber !== "" &&
        basicinformation.additionalDetails?.eleMbttNumber !==
          formik.values?.mbttNumber) ||
      (formik.values?.biography !== undefined &&
        formik.values?.biography !== null &&
        basicinformation.additionalDetails?.eleBiography !==
          formik.values?.biography) ||
      (formik.values?.facebookLink !== undefined &&
        formik.values?.facebookLink !== null &&
        socialMediaDetails.eleFacebookLink !== formik.values?.facebookLink) ||
      (formik.values?.twitterLink !== undefined &&
        formik.values?.twitterLink !== null &&
        socialMediaDetails.eleTwitterLink !== formik.values?.twitterLink) ||
      (formik.values?.linkedInLink !== undefined &&
        formik.values?.linkedInLink !== null &&
        socialMediaDetails.eleLinkedInLink !== formik.values?.linkedInLink)
    ) {
      if (
        basicinformation.additionalDetails.eleId !== null &&
        basicinformation.additionalDetails.eleId !== ""
      ) {
        Object.assign(additionalDetails, {
          eleId: basicinformation.additionalDetails.eleId,
        });
      }
      if (formik.values.birthDate !== null && formik.values.birthDate !== "") {
        Object.assign(additionalDetails, {
          eleDob: moment(formik.values.birthDate).format("YYYY-MM-DD"),
        });
      } else {
        Object.assign(additionalDetails, {
          eleDob: null,
        });
      }
      if (
        formik.values.totalExperiance !== null &&
        formik.values.totalExperiance !== ""
      ) {
        Object.assign(additionalDetails, {
          eleYearOfExperience: formik.values.totalExperiance,
        });
      } else {
        Object.assign(additionalDetails, {
          eleYearOfExperience: null,
        });
      }
      Object.assign(additionalDetails, {
        eliId: formik.values.eliId,
      });
      Object.assign(additionalDetails, {
        eleDepartmentEliName: formik.values.department,
      });

      if (formik.values.biography !== null && formik.values.biography !== "") {
        Object.assign(additionalDetails, {
          eleBiography: formik.values.biography,
        });
      } else {
        Object.assign(additionalDetails, {
          eleBiography: null,
        });
      }

      if (
        formik.values.mbttNumber !== null &&
        formik.values.mbttNumber !== ""
      ) {
        Object.assign(additionalDetails, {
          eleMbttNumber: formik.values.mbttNumber,
        });
      } else {
        Object.assign(additionalDetails, {
          eleMbttNumber: null,
        });
      }
      if (
        formik.values.facebookLink !== null &&
        formik.values.facebookLink !== ""
      ) {
        Object.assign(additionalDetails, {
          eleFacebookLink: formik.values.facebookLink,
        });
      } else {
        Object.assign(additionalDetails, {
          eleFacebookLink: null,
        });
      }
      if (
        formik.values.twitterLink !== null &&
        formik.values.twitterLink !== ""
      ) {
        Object.assign(additionalDetails, {
          eleTwitterLink: formik.values.twitterLink,
        });
      } else {
        Object.assign(additionalDetails, {
          eleTwitterLink: null,
        });
      }
      if (
        formik.values.linkedInLink !== null &&
        formik.values.linkedInLink !== ""
      ) {
        Object.assign(additionalDetails, {
          eleLinkedInLink: formik.values.linkedInLink,
        });
      } else {
        Object.assign(additionalDetails, {
          eleLinkedInLink: null,
        });
      }
    }

    return additionalDetails;
  };

  const pricingDetails = () => {
    let hpPriceDetails = {};
    //This if is used for creating edited post data object pricing component
    if (
      pricingData.etpId !== undefined &&
      pricingData.etpId !== null &&
      pricingData.etpId !== "" &&
      formik.values?.enterAmount !== undefined &&
      formik.values?.enterAmount !== null &&
      formik.values?.enterAmount !== "" &&
      formik.values?.price === true
    ) {
      if (pricingData.etpDefaultPrice !== formik.values.enterAmount) {
        Object.assign(hpPriceDetails, {
          etpId:
            formik.values.etpId !== undefined && formik.values.etpId !== null
              ? formik.values.etpId
              : "",
          etpDefaultPrice: formik.values.enterAmount,
        });
      }
    }
    if (
      pricingData.etpId !== undefined &&
      pricingData.etpId !== null &&
      pricingData.etpId !== "" &&
      formik.values?.price === false &&
      pricingData.etpDefaultPrice !== undefined &&
      pricingData.etpDefaultPrice !== null &&
      pricingData.etpDefaultPrice !== "" &&
      pricingData.etpDefaultPrice !== 0
    ) {
      Object.assign(hpPriceDetails, {
        etpId:
          formik.values.etpId !== undefined && formik.values.etpId !== null
            ? formik.values.etpId
            : "",
        etpDefaultPrice: "0.00",
      });
    }
    if (pricingData.etpId === undefined || pricingData.etpId === "") {
      if (formik.values?.price === false) {
        Object.assign(hpPriceDetails, {
          etpDefaultPrice: "0.00",
        });
      } else {
        Object.assign(hpPriceDetails, {
          etpDefaultPrice: formik.values.enterAmount,
        });
      }
    }
    return hpPriceDetails;
  };

  const educationDetail = () => {
    let educationDetailData: any[] = [];
    //This for loop is used for creating deletd post data object of Education component
    deletedEeaId?.forEach((educationElement: any) => {
      educationDetailData.push({
        eeaId: educationElement,
        delete: "true",
      });
    });

    //This for loop is used for creating Edited post data object of Education component
    educationDetails.forEach((element: any) => {
      formik?.values?.educations?.forEach((formikElement: any, index: any) => {
        if (
          element.eeaId === formikElement.eeaId &&
          formikElement.college === "" &&
          formikElement.degree === "" &&
          (formikElement.educationDate === "" ||
            formikElement.educationDate === null)
        ) {
          educationDetailData.push({
            eeaId: formikElement.eeaId,
            delete: "true",
          });
          return;
        }
        if (
          formikElement.eeaId !== undefined &&
          formikElement.eeaId !== "new" &&
          element.eeaId === formikElement.eeaId
        ) {
          if (
            element.eeaDegree !== formikElement.degree ||
            element.eeaInstituteName !== formikElement.college ||
            (element.eeaDate !== undefined &&
              element.eeaDate !== null &&
              element.eeaDate !== "" &&
              moment(formikElement.educationDate).isValid() !== false &&
              element.eeaDate !==
                moment(formikElement.educationDate).format("YYYY-MM-DD"))
          ) {
            let educationDetailCurrentData = {};

            Object.assign(educationDetailCurrentData, {
              eeaId: formikElement.eeaId,
            });

            if (element.eeaDegree !== formikElement.degree) {
              Object.assign(educationDetailCurrentData, {
                degree: formikElement.degree,
              });
            }

            if (element.eeaInstituteName !== formikElement.college) {
              Object.assign(educationDetailCurrentData, {
                instituteName: formikElement.college,
              });
            }

            if (
              element.eeaDate !== undefined &&
              element.eeaDate !== null &&
              element.eeaDate !== "" &&
              formikElement.educationDate !== undefined &&
              formikElement.educationDate !== null &&
              formikElement.educationDate !== "" &&
              moment(formikElement.educationDate).isValid() !== false &&
              element.eeaDate !==
                moment(formikElement.educationDate).format("YYYY-MM-DD")
            ) {
              Object.assign(educationDetailCurrentData, {
                date: moment(formikElement.educationDate).format("YYYY-MM-DD"),
              });
            }
            educationDetailData.push(educationDetailCurrentData);
          }
        }
      });
    });

    //This for loop is used for creating new post data object of Education component
    formik?.values?.educations.forEach((element: any) => {
      if (
        element.eeaId === "new" &&
        element.college === "" &&
        element.degree === "" &&
        (element.educationDate === "" || element.educationDate === null)
      ) {
        return;
      }

      if (
        element.eeaId === "new" &&
        (element.degree !== undefined ||
          element.degree !== null ||
          element.degree !== "") &&
        (element.college !== undefined ||
          element.college !== null ||
          element.college !== "") &&
        (element.educationDate !== undefined ||
          element.educationDate !== null ||
          element.educationDate !== "" ||
          moment(element.educationDate).isValid() !== false)
      ) {
        educationDetailData.push({
          degree: element.degree,
          instituteName: element.college,
          date: moment(element.educationDate).format("YYYY-MM-DD"),
        });
      }
    });
    return educationDetailData;
  };

  const serviceDetailsData = () => {
    let serviceDetailsData: any[] = [];
    //This for loop is used for creating edited post data object of service component

    formik?.values?.service?.forEach((formikServiceElement: any) => {
      serviceDetailsData.push({
        eliId: formikServiceElement.eliId,
        eliText: formikServiceElement.eliText,
      });
    });
    return serviceDetailsData;
  };

  const specializationDetailsData = () => {
    let specializationDetailsData: any[] = [];
    //This for loop is used for creating edited post data object of specialization component
    formik?.values?.specialization?.forEach(
      (formikSpecializationElement: any) => {
        specializationDetailsData.push({
          eliId: formikSpecializationElement.eliId,
          eliText: formikSpecializationElement.eliText,
        });
      }
    );

    return specializationDetailsData;
  };

  const experienceDetail = () => {
    let experienceDetailsData: any[] = [];
    //This for loop is used for creating deleted post data object of experiance component
    deletedExperianceEeaId?.forEach((experianceElement: any) => {
      experienceDetailsData.push({
        eeaId: experianceElement,
        delete: "true",
      });
    });

    //This for loop is used for creating edited post data object of experiance component
    experianceDetails.forEach((experianceElement: any) => {
      formik?.values?.experinces?.forEach((formikExperianceElement: any) => {
        if (
          experianceElement.eeaId === formikExperianceElement.eeaId &&
          formikExperianceElement.hospital === "" &&
          (formikExperianceElement.experinceStartDate === "" ||
            formikExperianceElement.experinceStartDate === null) &&
          (formikExperianceElement.experinceEndDate === "" ||
            formikExperianceElement.experinceEndDate === null) &&
          formikExperianceElement.designation === ""
        ) {
          experienceDetailsData.push({
            eeaId: formikExperianceElement.eeaId,
            delete: "true",
          });
          return;
        }
        if (
          formikExperianceElement.eeaId !== undefined &&
          formikExperianceElement.eeaId !== "new" &&
          experianceElement.eeaId === formikExperianceElement.eeaId
        ) {
          if (
            experianceElement.eeaOrganizationName !==
              formikExperianceElement.hospital ||
            (moment(formikExperianceElement.experinceStartDate).isValid() !==
              false &&
              experianceElement.eeaExperienceStartDate !==
                moment(formikExperianceElement.experinceStartDate).format(
                  "YYYY-MM-DD"
                )) ||
            (moment(formikExperianceElement.experinceEndDate).isValid() !==
              false &&
              experianceElement.eeaExperienceEndDate !==
                moment(formikExperianceElement.experinceEndDate).format(
                  "YYYY-MM-DD"
                )) ||
            experianceElement.eeaDesignation !==
              formikExperianceElement.designation
          ) {
            let experienceDetailCurrentData = {};

            Object.assign(experienceDetailCurrentData, {
              eeaId: formikExperianceElement.eeaId,
            });

            if (
              experianceElement.eeaOrganizationName !==
              formikExperianceElement.hospital
            ) {
              Object.assign(experienceDetailCurrentData, {
                organizationName: formikExperianceElement.hospital,
              });
            }

            if (
              experianceElement.eeaExperienceStartDate !== undefined &&
              experianceElement.eeaExperienceStartDate != null &&
              experianceElement.eeaExperienceStartDate !== "" &&
              formikExperianceElement.experinceStartDate !== undefined &&
              formikExperianceElement.experinceStartDate !== null &&
              formikExperianceElement.experinceStartDate !== "" &&
              moment(formikExperianceElement.experinceStartDate).isValid() !==
                false &&
              experianceElement.eeaExperienceStartDate !==
                moment(formikExperianceElement.experinceStartDate).format(
                  "YYYY-MM-DD"
                )
            ) {
              Object.assign(experienceDetailCurrentData, {
                experienceStartDate: moment(
                  formikExperianceElement.experinceStartDate
                ).format("YYYY-MM-DD"),
              });
            }

            if (
              experianceElement.eeaExperienceEndDate !== undefined &&
              experianceElement.eeaExperienceEndDate !== null &&
              experianceElement.eeaExperienceEndDate !== "" &&
              formikExperianceElement.experinceEndDate !== undefined &&
              formikExperianceElement.experinceEndDate !== null &&
              formikExperianceElement.experinceEndDate !== "" &&
              moment(formikExperianceElement.experinceEndDate).isValid() !==
                false &&
              experianceElement.eeaExperienceEndDate !==
                moment(formikExperianceElement.experinceEndDate).format(
                  "YYYY-MM-DD"
                )
            ) {
              Object.assign(experienceDetailCurrentData, {
                experienceEndDate: moment(
                  formikExperianceElement.experinceEndDate
                ).format("YYYY-MM-DD"),
              });
            }

            if (
              experianceElement.eeaDesignation !==
              formikExperianceElement.designation
            ) {
              Object.assign(experienceDetailCurrentData, {
                designation: formikExperianceElement.designation,
              });
            }
            experienceDetailsData.push(experienceDetailCurrentData);
          }
        }
      });
    });

    //This for loop is used for creating new post data object of experiance component
    formik?.values?.experinces.forEach((element: any) => {
      if (
        element.eeaId === "new" &&
        element.hospital === "" &&
        (element.experinceStartDate === "" ||
          element.experinceStartDate === null) &&
        (element.experinceEndDate === "" ||
          element.experinceEndDate === null) &&
        element.designation === ""
      ) {
        return;
      }
      if (
        element.eeaId === "new" &&
        (element.hospital !== undefined ||
          element.hospital !== null ||
          element.hospital !== "") &&
        (element.experinceStartDate !== undefined ||
          element.experinceStartDate !== null ||
          element.experinceStartDate !== "" ||
          moment(element.experinceStartDate).isValid() !== false) &&
        (element.experinceEndDate !== undefined ||
          element.experinceEndDate !== null ||
          element.experinceEndDate !== "" ||
          moment(element.experinceEndDate).isValid() !== false) &&
        (element.designation !== undefined ||
          element.designation !== null ||
          element.designation !== "")
      ) {
        experienceDetailsData.push({
          organizationName: element.hospital,
          experienceStartDate:
            moment(element.experinceStartDate).isValid() !== false
              ? moment(element.experinceStartDate).format("YYYY-MM-DD")
              : null,
          experienceEndDate:
            moment(element.experinceEndDate).isValid() !== false
              ? moment(element.experinceEndDate).format("YYYY-MM-DD")
              : null,
          designation: element.designation,
        });
      }
    });

    return experienceDetailsData;
  };

  const awardDetail = () => {
    let awardDetailsData: any[] = [];
    //This for loop is used for creating delete post data object of awards component

    deletedAwardEeaId?.forEach((awardsElement: any) => {
      awardDetailsData.push({
        eeaId: awardsElement,
        delete: "true",
      });
    });

    //This for loop is used for creating edited post data object of awards component
    awardsDetails.forEach((awardsElement: any) => {
      formik?.values?.awards?.forEach((formikAwardsElement: any) => {
        if (
          awardsElement.eeaId === formikAwardsElement.eeaId &&
          formikAwardsElement.collegeawards === "" &&
          (formikAwardsElement.awardsDate === "" ||
            formikAwardsElement.awardsDate === null)
        ) {
          awardDetailsData.push({
            eeaId: formikAwardsElement.eeaId,
            delete: "true",
          });
          return;
        }

        if (
          formikAwardsElement.eeaId !== undefined &&
          formikAwardsElement.eeaId !== "new" &&
          awardsElement.eeaId === formikAwardsElement.eeaId
        ) {
          if (
            awardsElement.eeaInstituteName !==
              formikAwardsElement.collegeawards ||
            (awardsElement.eeaDate !== undefined &&
              awardsElement.eeaDate !== null &&
              awardsElement.eeaDate !== "" &&
              moment(formikAwardsElement.awardsDate).isValid() !== false &&
              awardsElement.eeaDate !==
                moment(formikAwardsElement.awardsDate).format("YYYY-MM-DD"))
          ) {
            let awardDetailCurrentData = {};

            Object.assign(awardDetailCurrentData, {
              eeaId: formikAwardsElement.eeaId,
            });

            if (
              awardsElement.eeaInstituteName !==
              formikAwardsElement.collegeawards
            ) {
              Object.assign(awardDetailCurrentData, {
                instituteName: formikAwardsElement.collegeawards,
              });
            }

            if (
              awardsElement.eeaDate !== undefined &&
              awardsElement.eeaDate !== null &&
              awardsElement.eeaDate !== "" &&
              formikAwardsElement.awardsDate !== undefined &&
              formikAwardsElement.awardsDate !== null &&
              formikAwardsElement.awardsDate !== "" &&
              awardsElement.eeaDate !==
                moment(formikAwardsElement.awardsDate).format("YYYY-MM-DD")
            ) {
              Object.assign(awardDetailCurrentData, {
                date: moment(formikAwardsElement.awardsDate).format(
                  "YYYY-MM-DD"
                ),
              });
            }
            awardDetailsData.push(awardDetailCurrentData);
          }
        }
      });
    });

    //This for loop is used for creating new post data object of awards component
    formik?.values?.awards.forEach((element: any) => {
      if (
        element.eeaId === "new" &&
        element.collegeawards === "" &&
        (element.awardsDate === "" || element.awardsDate === null)
      ) {
        return;
      }
      if (
        element.eeaId === "new" &&
        (element.collegeawards !== undefined ||
          element.collegeawards !== null ||
          element.collegeawards !== "") &&
        (element.awardsDate !== undefined ||
          element.awardsDate !== null ||
          element.awardsDate !== "" ||
          moment(element.awardsDate).isValid() !== false)
      ) {
        awardDetailsData.push({
          instituteName: element.collegeawards,
          date: moment(element.awardsDate).format("YYYY-MM-DD"),
        });
      }
    });

    return awardDetailsData;
  };

  const CheckDuplicateUserEmail = async (value: any) => {
    console.log(value, "check");

    try {
      const response = await getRequest("checkDuplicateUserEmail", {
        params: { email: value },
      });

      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setIsUserEmailPresent(
          basicinformation?.useEmail !== formik?.values?.emailId
            ? response?.data
            : false
        );
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const CheckDuplicateUserMobile = async (value: any) => {
    try {
      const response = await getRequest("checkDuplicateUserMobile", {
        params: { mobile: value },
      });

      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setIsUserMobilePresent(
          basicinformation?.useMobile !== formik?.values?.mobileNo
            ? response?.data
            : false
        );
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const formik = useFormik({
    initialValues: clinicianDetailobject,
    validationSchema: Yup.object({
      userName: Yup.string(),
      emailId: Yup.string()
        .email("Please enter valid email.")
        .required("Email Required"),
      birthDate: Yup.date()
        .typeError("Please select a valid date")
        .nullable()
        .min(new Date("01/01/1900"), "Please select a valid date")
        .max(new Date(), "Date selected is future date"),

      firstName: Yup.string()
        .max(30, "Firstname must be under 30 characters.")
        .min(3, "Firstname must be more than 3 characters.")
        .required("First Name Required")
        .matches(alphabetsRgex, "Only alphabets are allowed"),

      lastName: Yup.string()
        .max(30, "Lastname must be under 30 characters.")
        .min(3, "Lastname must be more than 3 characters.")
        .required("Last Name Required")
        .matches(alphabetsRgex, "Only alphabets are allowed"),
      gender: Yup.string().required("Please Select Gender"),
      mbttNumber: Yup.string()
        .required("Please enter MBTT number")
        .matches(alphabetsNumberRegex, "Only alphabets and numbers are allowed")
        .max(10, "MBTT number must be under 10 characters."),
      department: Yup.string().required("Please Select Department"),
      mobileNo: Yup.string()
        .required("Mobile Number Required")
        .matches(mobileNoRegex, "Please enter valid mobile number"),
      biography: Yup.string().max(500, "About me must be under 500 characters"),
      enterAmount: Yup.string().test(
        "required",
        "Please enter amount",
        (value: any, context: any) => {
          if (
            context.parent.price &&
            (value === undefined || value === null || value === "")
          ) {
            return false;
          }
          return true;
        }
      ),
      facebookLink: Yup.string().matches(
        facebookRegex,
        "Invalid Facebook Link"
      ),
      twitterLink: Yup.string().matches(twitterRegex, "Invalid Twitter Link"),
      linkedInLink: Yup.string().matches(
        linkedinRegex,
        "Invalid Linkedin Link"
      ),

      awards: Yup.array().of(
        Yup.object().shape({
          awardsDate: Yup.date()
            .typeError("Please select a valid date")
            .nullable()
            .min(new Date("01/01/1900"), "Please select a valid date")
            .max(new Date(), "Date selected is future date"),
        })
      ),

      educations: Yup.array().of(
        Yup.object().shape({
          educationDate: Yup.date()
            .typeError("Please select a valid date")
            .nullable()
            .min(new Date("01/01/1900"), "Please select a valid date")
            .max(new Date(), "Date selected is future date"),
        })
      ),

      experinces: Yup.array().of(
        Yup.object().shape({
          experinceStartDate: Yup.date()
            .typeError("Please select a valid date")
            .nullable()
            .min(new Date("01/01/1900"), "Please select a valid date")
            .max(new Date(), "Date selected is future date")
            .test(
              "startDate-required-if-endDate",
              "Start Date should be selected if End Date is set",
              function (value) {
                const { experinceEndDate } = this.parent;
                if (experinceEndDate && !value) {
                  return this.createError({
                    path: `${this.path}`,
                    message: "Start Date should be selected if End Date is set",
                  });
                }
                return true;
              }
            ),
          experinceEndDate: Yup.date()
            .typeError("Please select a valid date")
            .nullable()
            .min(new Date("01/01/1900"), "Please select a valid date")
            .max(new Date(), "Date selected is future date")
            .test(
              "endDate-required-if-startDate",
              "End Date should be selected if Start Date is set",
              function (value) {
                const { experinceStartDate } = this.parent;
                if (experinceStartDate && !value) {
                  return this.createError({
                    path: `${this.path}`,
                    message: "End Date should be selected if Start Date is set",
                  });
                }
                return true;
              }
            )
            .test(
              "is-greater",
              "End date must be later than start date",
              function (value) {
                const { experinceStartDate } = this.parent;
                return (
                  !experinceStartDate || !value || value >= experinceStartDate
                );
              }
            ),
        })
      ),
    }),

    onSubmit: async () => {
      let clinicianData = {};
      if (isUserEmailPresent || isUserMobilePresent) {
        window.scrollTo(0, 0);
      } else {
        let basicInformationData = basicInformation();
        if (Object.keys(basicInformationData).length !== 0) {
          Object.assign(clinicianData, {
            userDetails: basicInformationData,
          });
        }

        let additionalDetailsData = additionalDetails();
        if (Object.keys(additionalDetailsData).length !== 0) {
          Object.assign(clinicianData, {
            additionalDetailsJson: additionalDetailsData,
          });
        }
        let pricingDetailsData = pricingDetails();
        if (Object.keys(pricingDetailsData).length !== 0) {
          Object.assign(clinicianData, {
            hpPriceDetails: pricingDetailsData,
          });
        }

        let serviceDetails = serviceDetailsData();
        if (Object.keys(serviceDetails).length !== 0) {
          Object.assign(clinicianData, {
            service: serviceDetails,
          });
        }

        let specializationDetails = specializationDetailsData();
        if (Object.keys(specializationDetails).length !== 0) {
          Object.assign(clinicianData, {
            specialization: specializationDetails,
          });
        }

        let educationDetailData = educationDetail();
        if (Object.keys(educationDetailData).length !== 0) {
          Object.assign(clinicianData, {
            educationDetails: educationDetailData,
          });
        }

        let experienceDetailData = experienceDetail();
        if (Object.keys(experienceDetailData).length !== 0) {
          Object.assign(clinicianData, {
            experienceDetails: experienceDetailData,
          });
        }

        let awardDetailData = awardDetail();
        if (Object.keys(awardDetailData).length !== 0) {
          Object.assign(clinicianData, {
            awardDetails: awardDetailData,
          });
        }

        setDisableSubmit(true);

        const response = await postAxios(
          "establishmentProfessionals",
          clinicianData,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );
        if (response.toString() === "ERROR") {
          dispatch(
            setSnackbar(
              true,
              undefined,
              "warning",
              "Cellmaflex has encounter an issue. Please contact administrator.",
              "top",
              "center"
            )
          );
          setDisableSubmit(false);
        } else if (response.toString() !== "" && typeof response !== "object") {
          setDisableSubmit(false);
          dispatch(
            setSnackbar(
              true,
              undefined,
              "warning",
              response.toString(),
              "top",
              "center"
            )
          );
          singoutHandler(jwtToken);
          localStorage.removeItem("token");
          history("/signin");
        } else if (
          response?.data !== null &&
          response?.data !== undefined &&
          response?.data !== ""
        ) {
          if (response?.data?.establishmentProfessionals === "true") {
            successMessage.push("User Details has been saved successfully!\n");
          }

          if (response?.data?.hpAdditionalDetails === "true") {
            successMessage.push(
              "Establishment professional additional details has been saved successfully!\n"
            );
          }

          if (response?.data?.defaultPrices === "true") {
            successMessage.push("Price has been modified successfully!\n");
            setUpdatePriceLoader(true);
          }
          if (
            response?.data?.establishmentProfessionals === "true" ||
            response?.data?.hpAdditionalDetails === "true"
          ) {
            setUpdateBasicInfoLoader(true);
          }

          if (response?.data?.educationDetails === "true") {
            successMessage.push(
              "Education Details has been saved successfully!\n"
            );
            setUpdateEducationLoader(true);
          }

          if (response?.data?.experiencesDetails === "true") {
            successMessage.push(
              "Experiences Details has been saved successfully!\n"
            );
            setUpdateExperianceLoader(true);
          }
          if (response?.data?.awardsDetails === "true") {
            successMessage.push("Award Details has been saved successfully!\n");
            setUpdateAwardLoader(true);
          }

          if (response?.data?.services === "true") {
            successMessage.push(
              "Services Details has been saved successfully!\n"
            );
            setUpdateServiceSpecializationLoader(true);
          }

          if (response?.data?.specialization === "true") {
            successMessage.push(
              "Specilization Details has been saved successfully!\n"
            );
            setUpdateServiceSpecializationLoader(true);
          }

          setDisableSubmit(false);
        }
      }
    },
  });

  return (
    <CommonLayout showHeaderNavigation={true} isLogedIn={true}>
      <BasicInformation
        formik={formik}
        sendBasicinformation={getBasicinformation}
        loader={updateBasicInfoLoader}
        sendSocialMediaLoader={getSocialMediaLoader}
        sendCloseSnackbar={getCloseSnackbar}
        CheckDuplicateUserEmail={CheckDuplicateUserEmail}
        isUserEmailPresent={isUserEmailPresent}
        CheckDuplicateUserMobile={CheckDuplicateUserMobile}
        isUserMobilePresent={isUserMobilePresent}
      />

      <ClinicainPricing
        formik={formik}
        sendPrice={getPrice}
        loader={updatePriceLoader}
        sendCloseSnackbar={getCloseSnackbar}
      />

      <ClinicianEducation
        sendEducationEeaId={getEducationEeaId}
        sendEducationDetails={getEducationDetails}
        formik={formik}
        loader={updateEducationLoader}
        sendCloseSnackbar={getCloseSnackbar}
      />
      <ClinicianExperience
        sendExperianceEeaId={getExperianceEeaId}
        sendExperianceDetails={getExperianceDetails}
        formik={formik}
        loader={updateExperianceLoader}
        sendCloseSnackbar={getCloseSnackbar}
      />

      <ClinicianAwards
        sendAwardEeaId={getAwardEeaId}
        sendAwardsDetails={getAwardsDetails}
        formik={formik}
        sendCloseSnackbar={getCloseSnackbar}
        loader={updateAwardLoader}
      />

      <ClinicianSocialMedia
        formik={formik}
        getSocialMedia={basicinformation}
        loader={updateBasicInfoLoader}
        socialMediaStartLoader={socialMediaLoader.current}
      />
      <Grid container spacing={2} direction="row">
        <Grid item xs={12} md={12}>
          <form onSubmit={formik.handleSubmit}>
            <ButtonComponent
              className={classes.submitButton}
              variant="contained"
              size="small"
              type="submit"
              disabled={disableSubmit}
              label="Submit"
            />
          </form>
        </Grid>
      </Grid>
    </CommonLayout>
  );
};

export default ClinicianMain;
